import { getScreenWidth } from './getScreenWidth.js';

const sortComparatorAscending = (a, b) => a - b;

function findPositionInArray(array, value) { // If it were in array
  return [...array, value]
    .sort(sortComparatorAscending)
    .indexOf(value);
}

function throttle(func, timeFrame) {
  let lastTime = 0;
  return () => {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func();
      lastTime = now;
    }
  };
}

// Callback is called only when width passes a breakpoint
export function addResizeListener(breakpoints, callback) {
  let previousWidthIndex = -1;

  window.addEventListener('resize', throttle(() => {
    const width = getScreenWidth();
    const widthIndex = findPositionInArray(breakpoints, width);

    if (widthIndex === previousWidthIndex) {
      return;
    }
    previousWidthIndex = widthIndex;
    callback();
  }, 200));
}
